<template>
    <div class="checkout-total">
        <!--price-->
        <div class="checkout-total__row">
            <p class="checkout-total__name">
                {{ messages.price }}
            </p>
            <p class="checkout-total__value">
                {{ price.printPriceOld || basketPrices.printPriceOld || price.printPrice }}
            </p>
        </div>
        <!--discount-->
        <div v-if="price.printDiscount" class="checkout-total__row">
            <p class="checkout-total__name">
                {{ messages.discountPrice }}
            </p>
            <div class="checkout-total__value">
                <DefSale class="checkout-total__value">
                    - {{ price.discountPriceFormated }}
                </DefSale>
            </div>
        </div>

        <!--Sova club-->
        <div v-if="getSovaClub" class="checkout-total__row">
            <p class="checkout-total__name">
                SOVA Club
            </p>
            <p class="checkout-total__value">
                <DefSale>
                    - {{ getSovaClub.value }}
                </DefSale>
            </p>
        </div>

        <!--certificate-->
        <div
            v-if="basketPrices.certificates && basketMessages.certificates"
            class="checkout-total__row"
        >
            <p class="checkout-total__name">
                {{ basketMessages.certificates.title }}
            </p>
            <p class="checkout-total__value">
                <DefSale>
                    - {{ basketPrices.printCertificatesTotalPrice }}
                </DefSale>
            </p>
        </div>

        <!--coupons-->
        <div
            v-if="getBasketCoupon"
            class="checkout-total__row"
        >
            <p class="checkout-total__name">
                {{ basketMessages.coupons.code }}
            </p>
            <p class="checkout-total__value">
                <DefSale>
                    - {{ getBasketCoupon.value }}
                </DefSale>
            </p>
        </div>

        <!--Installments-->
        <div
            v-if="price.psPrice"
            class="checkout-total__row"
        >
            <p class="checkout-total__name">
                {{ messages.firstPay }}
            </p>
            <p class="checkout-total__value">
                {{ price.psPrice.printPsMonthlyPrice }}
            </p>
        </div>
        <div
            v-if="price.psPrice"
            class="checkout-total__row"
        >
            <p class="checkout-total__name">
                {{ messages.numberOfPayments }}
            </p>
            <p class="checkout-total__value">
                    <span>
                        {{ price.psPrice.partsCount }}
                    </span>
            </p>
        </div>
        <div
            v-if="price.psPrice"
            class="checkout-total__row"
        >
            <p class="checkout-total__name">
                {{ messages.monthlyPay }}
            </p>
            <p class="checkout-total__value">
                {{ price.psPrice.printPsMonthlyPrice }}
            </p>
        </div>

        <!--delivery-->
        <div class="checkout-total__row">
            <p class="checkout-total__name">
                {{ messages.delivery }}
            </p>
            <p
                v-if="getActiveDelivery.PRICE === 0"
                class="checkout-total__free"
            >
                {{ delivery?.messages?.freeDelivery }}
            </p>
            <p v-else class="checkout-total__value">
                {{ getActiveDelivery.PRICE_FORMATED }}
            </p>
        </div>
        <!--total-->
        <div class="checkout-total__row">
            <p class="checkout-total__name">
                {{ messages.totalPrice }}
            </p>
            <p class="checkout-total__total">
                {{ price.printPrice }}
            </p>
        </div>
        <CheckoutConfirmButton />
        <DefMessageError v-if="IPostErrorMessage">
            {{ IPostErrorMessage }}
        </DefMessageError>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

import DefSale from "../def/DefSale/DefSale";
import CheckoutConfirmButton from "./CheckoutConfirmButton";
import DefMessageError from "../def/DefMessages/DefMessageError";

export default {
    name: 'CheckoutTotal',
    components: {
        DefSale,
        CheckoutConfirmButton,
        DefMessageError,
    },
    computed: {
        ...mapState({
            price: ({ checkout }) => checkout.data.vue.basketPrice,
            basketPrices: ({ basket }) => basket.data.price,
            basketMessages: ({ basket }) => basket.data.messages,
            delivery: ({ checkout }) => checkout.data.vue?.delivery,
            messages: ({ checkout }) => checkout.data.vue.messages.payment,
            isAvailableIPost: ({ checkout }) => checkout.data.vue?.isAvailableIPost,
        }),
        ...mapGetters({
            getBasketCoupon: 'basket/getBasketCoupon',
            getSovaClub: 'basket/getSovaClub',
            getIPostDelivery: 'checkout/getIPostDelivery',
        }),
        getActiveDelivery() {
            return Object.values(this.delivery.items).find(el => el.CHECKED === 'Y')
        },
        IPostErrorMessage() {
            return this.getIPostDelivery?.CHECKED === 'Y' && !this.isAvailableIPost ? this.messages.iPostPriceError : null;
        },
    },
    methods: {
        ...mapMutations({
            changeOpenSmallBasket: 'basket/changeOpenSmallBasket',
        }),
        // handlerClick(e) {
        //     const invalidInput = document.querySelector('input:invalid');
        //     if (invalidInput) {
        //         App.helpers.scrollPageTo(window.scrollY + invalidInput.getBoundingClientRect().top - 100);
        //     }
        // },
    },
}
</script>

<style lang="scss" scoped>
.checkout-total{
    background-color: #fff;
    padding: 24px;
    display: grid;
    grid-row-gap: 12px;
    &__row{
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 8px;
        font-size: rem(14);
        font-weight: 500;
        @include point-md {
            font-size: rem(16);
        }

        & > *:first-child {
            line-height: 100%;
            color: #757575;
        }
    }
    &__name{
        justify-self: flex-start;
    }
    &__value{
        justify-self: flex-end;
    }
    &__free{
        justify-self: flex-end;
        color: var(--text-colour-secondary);
    }
    &__total{
        justify-self: flex-end;
        font-size: rem(20);
    }
}
.checkout-total{

}
</style>